module.exports = __webpack_public_path__ + "media/scales.e7c0c998.webm";